import {defaultConfiguration, defaultConfigurationModules, IConfiguration} from "../configuration.state";
const CONFIGURATION_VERNIY:IConfiguration = {
  ...defaultConfiguration,
  api: {
    ...defaultConfiguration.api,
    protocol: 'http',
    port: '80'
  },
  theme: 'verniy',
  language: {
    defaultLang: 'ru',
    showLang: true,
    langList: ['en', 'ru', 'ro', 'ua']
  },
  pagesConfig: {
    ...defaultConfigurationModules,
    login:{
      ...defaultConfigurationModules.login,
      loginType: 'common',
      supportEmail: 'support@redfactory.io',
      goFAQ: '',
      enableRestorePassword: false,
      enableSelfRegistration: false,
      enableGoogleSignIn: false,
      showTutorialVideo: false,
      showTryDemoButton: false,
      showAboutUsButton: true,
      showContacts: true,
      showContactOnlyEmail: true,
      contactsConfig: {
        showViber: false,
        showPhone: false,
        showEmail: true
      }
    },
    main:{
      showSupportBlock: false
    },
    dataLedger: {
      ...defaultConfigurationModules.dataLedger,
      showAddressForPartner: true
    },
    chat: {
      enabled: false
    }
  }
};
export const CONFIGURATION_VERNIY_DEV:IConfiguration = {
  ...CONFIGURATION_VERNIY
};
export const CONFIGURATION_VERNIY_PROD:IConfiguration = {
  ...CONFIGURATION_VERNIY
};
